import { useCallback } from 'react';
import { useImmerAtom } from 'jotai-immer';
import { activityStateAtom, ActivityState } from './activity_atoms';
import datamonitorRepo from '../../data/datamonitorRepo';

type UseActivityDataReturn = ActivityState & {
    load: () => Promise<void>;
};

export const useActivityData = (): UseActivityDataReturn => {
    const [state, setState] = useImmerAtom(activityStateAtom);

    const load = useCallback(async (): Promise<void> => {
        setState(draft => {
            draft.waiting = true;
            draft.error = null;
        });
        try {
            const data = await datamonitorRepo.getActivity();
            setState(draft => {
                draft.data = data;
                draft.init = false;
                draft.waiting = false;
            });
        } catch {
            setState(draft => {
                draft.init = false;
                draft.waiting = false;
                draft.error = 'Unable to load activity.';
            });
        }
    }, [setState]);

    return { ...state, load };
};
